import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getGraphPercentile = createApi(`GraphPercentile`,"GET");

const GraphPercentile = createSlice({
  name: 'GraphPercentile',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGraphPercentile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGraphPercentile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getGraphPercentile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GraphPercentile.reducer;